export const getAuthenticateRequest = (payload) => {
    return {
      url: "/api/Users/authenticate",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };
  };

export const getPasswordResetRequest = (password, token) => {
  return {
    url: "/api/Users/password",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      login: token,
      password: password,
    }),
  };
};

export const getSendResetLinkRequest = (payload) => {
  return {
    url: "/api/Users/reset",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
};
